import {
  mockCheckboxListGroups,
  mockCheckboxListGroupsPrestationsAndAmenagements,
  mockCheckboxListGroupsRichCanaux,
  mockCheckboxListGroupsSingleOption,
  mockCheckboxListGroupsNoHeader,
  mockCheckboxListGroupsMixedLayouts,
  mockCheckboxListGroupsRequired,
  mockCheckboxListGroupsColumnWithHeaders,
  mockCheckboxListHeadersAmenagements,
  DEFAULT_FORM_ITEM_LABEL_STYLE,
  createMockRadioGroup,
  createMockFormItemRadioList,
  createMockFormItemGridRights,
} from './mock-form-item';

/**
 * Mock form data with new OpenAPI structure.
 * Structure: tabs[].fieldsets[].fields[] with FormItem discriminated union.
 * Demo hideConditions: masked when a referenced field id has its current value in values.
 * Defaults: lieu_type is `salle`; try `club` or `autre`, or lieu_section `hors les murs`.
 * @type {ApiFormResponse}
 */
export const mockFormData = {
  searchUrl: null,
  sendFormUrl: '/form/submit/demo',
  params: [{ id: 'context_entity', values: ['12345'], singleValue: true }],
  tabs: [
    {
      id: 0,
      legend: '**Suivi** de prod',
      subLegend: '*Onglet principal* — fiches lieux et feuilles de route.',
      displayAnchors: true,
      fieldsets: [
        {
          id: 0,
          legend: '**Fiche** lieu — *données principales*',
          subLegend: 'Saisissez les informations du lieu. Consultez la [doc](https://example.com) pour plus d\'aide.',
          column: 0,
          fields: [
            // id_lieu (hidden)
            {
              text: {
                id: 'id_lieu',
                type: 'int',
                lib: 'Id',
                ...DEFAULT_FORM_ITEM_LABEL_STYLE,
                align: 'center',
                help: null,
                default: '',
                width: '',
                value: '',
                liveSearchEnabled: false,
                suggestionsUrl: null,
                validation: { required: false },
                hideConditions: [],
              },
              textarea: null,
              entity: null,
              select: null,
              selectClass: null,
              selectMultiple: null,
              selectMultipleClass: null,
              file: null,
              color: null,
              date: null,
              boolean: null,
              mergeTable: null,
              checkbox: null,
              checkboxList: null,
              grid: null,
            },
            // wysiwyg-field
            {
              text: null,
              textarea: {
                id: 'wysiwyg-field',
                type: 'wysiwyg',
                lib: 'Champs wysiwyg',
                ...DEFAULT_FORM_ITEM_LABEL_STYLE,
                value: '<p>Ceci est le <strong>contenu initial</strong> de l\'éditeur.</p>',
                help: null,
                default: '',
                width: '',
                validation: { required: false },
                hideConditions: [],
              },
              entity: null,
              select: null,
              selectClass: null,
              selectMultiple: null,
              selectMultipleClass: null,
              file: null,
              color: null,
              date: null,
              boolean: null,
              mergeTable: null,
              checkbox: null,
              checkboxList: null,
              grid: null,
            },
            // ressource_id (hidden)
            {
              text: {
                id: 'ressource_id',
                type: 'text',
                lib: 'ressourceId',
                ...DEFAULT_FORM_ITEM_LABEL_STYLE,
                align: 'left',
                help: null,
                default: '',
                width: '',
                value: '',
                liveSearchEnabled: false,
                suggestionsUrl: null,
                validation: { required: false },
                hideConditions: [],
              },
              textarea: null,
              entity: null,
              select: null,
              selectClass: null,
              selectMultiple: null,
              selectMultipleClass: null,
              file: null,
              color: null,
              date: null,
              boolean: null,
              mergeTable: null,
              checkbox: null,
              checkboxList: null,
              grid: null,
            },
            // lieu_section
            {
              text: {
                id: 'lieu_section',
                type: 'text',
                lib: 'Section',
                ...DEFAULT_FORM_ITEM_LABEL_STYLE,
                align: 'left',
                help: 'Permet de regrouper les lieux par thématique (mes salles, hors les murs, studios, salles du batiment principal, etc.)',
                default: '',
                width: '',
                value: '',
                liveSearchEnabled: false,
                suggestionsUrl: '/field-suggestions?classId=Lieu&field=lieu_section&contexte=%5B%5D',
                validation: { required: false },
                hideConditions: [],
              },
              textarea: null,
              entity: null,
              select: null,
              selectClass: null,
              selectMultiple: null,
              selectMultipleClass: null,
              file: null,
              color: null,
              date: null,
              boolean: null,
              mergeTable: null,
              checkbox: null,
              checkboxList: null,
              grid: null,
            },
            // lieu_piece_jointe (file - visible dans l'onglet principal)
            {
              text: null,
              textarea: null,
              entity: null,
              select: null,
              selectClass: null,
              selectMultiple: null,
              selectMultipleClass: null,
              file: {
                id: 'lieu_piece_jointe',
                lib: 'Pièce jointe',
                ...DEFAULT_FORM_ITEM_LABEL_STYLE,
                value: '',
                help: null,
                width: '',
                uploadUrl: '/api/upload/test',
                validation: { required: false },
                hideConditions: [{ id: 'lieu_type', values: ['club', 'autre'] }],
              },
              color: null,
              date: null,
              boolean: null,
              mergeTable: null,
              checkbox: null,
              checkboxList: null,
              grid: null,
            },
            // id_classification_cnv_lieu
            {
              text: {
                id: 'id_classification_cnv_lieu',
                type: 'int',
                lib: 'Classification CNM',
                ...DEFAULT_FORM_ITEM_LABEL_STYLE,
                align: 'center',
                help: 'Est utilisée sur les différents exports CNM (déclaration mensuelle, PDF événement et tableau commission 7)',
                default: '',
                width: '',
                value: '',
                liveSearchEnabled: false,
                suggestionsUrl: null,
                validation: { required: false },
                hideConditions: [],
              },
              textarea: null,
              entity: null,
              select: null,
              selectClass: null,
              selectMultiple: null,
              selectMultipleClass: null,
              file: null,
              color: null,
              date: null,
              boolean: null,
              mergeTable: null,
              checkbox: null,
              checkboxList: null,
              grid: null,
            },
            // id_type_lieu (hidden)
            {
              text: {
                id: 'id_type_lieu',
                type: 'int',
                lib: 'Libellé',
                ...DEFAULT_FORM_ITEM_LABEL_STYLE,
                align: 'center',
                help: null,
                default: '',
                width: '',
                value: '',
                liveSearchEnabled: false,
                suggestionsUrl: null,
                validation: { required: false },
                hideConditions: [],
              },
              textarea: null,
              entity: null,
              select: null,
              selectClass: null,
              selectMultiple: null,
              selectMultipleClass: null,
              file: null,
              color: null,
              date: null,
              boolean: null,
              mergeTable: null,
              checkbox: null,
              checkboxList: null,
              grid: null,
            },
            // lieu_type (enum)
            {
              text: null,
              textarea: null,
              entity: null,
              select: {
                id: 'lieu_type',
                lib: 'Type de salle',
                ...DEFAULT_FORM_ITEM_LABEL_STYLE,
                value: 'salle',
                help: 'Utilisé dans les exports CNM, permet de préciser que le type de salle.',
                default: 'salle',
                width: '',
                validation: { required: false },
                hideConditions: [],
                options: [
                  {
                    id: 'salle',
                    lib: 'salle',
                    optGroup: '',
                    color: '',
                  },
                  {
                    id: 'club',
                    lib: 'club',
                    optGroup: '',
                    color: '',
                  },
                  {
                    id: 'autre',
                    lib: 'autre',
                    optGroup: '',
                    color: '',
                  },
                ],
              },
              selectClass: null,
              selectMultiple: null,
              selectMultipleClass: null,
              file: null,
              color: null,
              date: null,
              boolean: null,
              mergeTable: null,
              checkbox: null,
              checkboxList: null,
              grid: null,
            },
            // lieu_type_multi (enum multiple)
            {
              text: null,
              textarea: null,
              entity: null,
              select: null,
              selectClass: null,
              selectMultiple: {
                id: 'lieu_type_multi',
                lib: 'Type de salle multi',
                ...DEFAULT_FORM_ITEM_LABEL_STYLE,
                values: [],
                help: 'Utilisé dans les exports CNM, permet de préciser que le type de salle multi.',
                default: ['salle'],
                width: '',
                validation: { required: false },
                hideConditions: [{ id: 'lieu_type', values: ['club'] }],
                options: [
                  {
                    id: 'salle',
                    lib: 'salle',
                    optGroup: '',
                    color: '',
                  },
                  {
                    id: 'club',
                    lib: 'club',
                    optGroup: '',
                    color: '',
                  },
                  {
                    id: 'autre',
                    lib: 'autre',
                    optGroup: '',
                    color: '',
                  },
                ],
              },
              selectMultipleClass: null,
              file: null,
              color: null,
              date: null,
              boolean: null,
              mergeTable: null,
              checkbox: null,
              checkboxList: null,
              grid: null,
            },
            // lieu_tags (checkboxList)
            {
              text: null,
              textarea: null,
              entity: null,
              select: null,
              selectClass: null,
              selectMultiple: null,
              selectMultipleClass: null,
              file: null,
              color: null,
              date: null,
              boolean: null,
              mergeTable: null,
              checkbox: null,
              checkboxList: {
                id: 'lieu_tags',
                values: ['rock', 'son'],
                ...DEFAULT_FORM_ITEM_LABEL_STYLE,
                help: 'Styles et équipements du lieu.',
                default: ['rock'],
                headers: [],
                groups: mockCheckboxListGroups,
                validation: { required: false },
                hideConditions: [{ id: 'lieu_type', values: ['autre'] }],
              },
              grid: null,
            },
            // lieu_visible_public (checkbox, pré-cochée, value string)
            {
              text: null,
              textarea: null,
              entity: null,
              select: null,
              selectClass: null,
              selectMultiple: null,
              selectMultipleClass: null,
              file: null,
              color: null,
              date: null,
              boolean: null,
              mergeTable: null,
              checkbox: {
                id: 'lieu_visible_public',
                lib: 'Visible sur le site public',
                ...DEFAULT_FORM_ITEM_LABEL_STYLE,
                help: 'Si coché, le lieu apparaît sur le site public.',
                checked: true,
                value: '1',
                validation: { required: false },
                hideConditions: [],
              },
              checkboxList: null,
              grid: null,
            },
            // lieu_cgu (checkbox, décochée, value null → soumet 'on' si cochée)
            {
              text: null,
              textarea: null,
              entity: null,
              select: null,
              selectClass: null,
              selectMultiple: null,
              selectMultipleClass: null,
              file: null,
              color: null,
              date: null,
              boolean: null,
              mergeTable: null,
              checkbox: {
                id: 'lieu_cgu',
                lib: 'J\'accepte les conditions d\'utilisation',
                ...DEFAULT_FORM_ITEM_LABEL_STYLE,
                help: null,
                checked: false,
                value: null,
                validation: { required: true },
                hideConditions: [],
              },
              checkboxList: null,
              grid: null,
            },
            // id_adresse (hidden)
            {
              text: {
                id: 'id_adresse',
                type: 'int',
                lib: 'Libellé',
                ...DEFAULT_FORM_ITEM_LABEL_STYLE,
                align: 'center',
                help: null,
                default: '',
                width: '',
                value: '',
                liveSearchEnabled: false,
                suggestionsUrl: null,
                validation: { required: false },
                hideConditions: [],
              },
              textarea: null,
              entity: null,
              select: null,
              selectClass: null,
              selectMultiple: null,
              selectMultipleClass: null,
              file: null,
              color: null,
              date: null,
              boolean: null,
              mergeTable: null,
              checkbox: null,
              checkboxList: null,
              grid: null,
            },
            // lib_lieu
            {
              text: {
                id: 'lib_lieu',
                type: 'text',
                lib: 'Nom interne',
                ...DEFAULT_FORM_ITEM_LABEL_STYLE,
                align: 'left',
                help: 'Ce nom est utilisé dans le manager Heeds uniquement.',
                default: '',
                width: '',
                value: 'Value',
                liveSearchEnabled: true,
                suggestionsUrl: null,
                validation: { required: false },
                hideConditions: [],
              },
              textarea: null,
              entity: null,
              select: null,
              selectClass: null,
              selectMultiple: null,
              selectMultipleClass: null,
              file: null,
              color: null,
              date: null,
              boolean: null,
              mergeTable: null,
              checkbox: null,
              checkboxList: null,
              grid: null,
            },
            // lib_lieu_public
            {
              text: {
                id: 'lib_lieu_public',
                type: 'text',
                lib: 'Nom public et pros',
                ...DEFAULT_FORM_ITEM_LABEL_STYLE,
                align: 'left',
                help: 'Utilisé sur les feuilles de route, confirmations, commandes, les exports site web, applications smartphones, etc.',
                default: '',
                width: '',
                value: '',
                liveSearchEnabled: false,
                suggestionsUrl: null,
                validation: { required: false },
                hideConditions: [{ id: 'lieu_type', values: ['autre'] }],
              },
              textarea: null,
              entity: null,
              select: null,
              selectClass: null,
              selectMultiple: null,
              selectMultipleClass: null,
              file: null,
              color: null,
              date: null,
              boolean: null,
              mergeTable: null,
              checkbox: null,
              checkboxList: null,
              grid: null,
            },
            // code_lieu
            {
              text: {
                id: 'code_lieu',
                type: 'text',
                lib: 'Code lieu',
                ...DEFAULT_FORM_ITEM_LABEL_STYLE,
                align: 'center',
                help: "Utilisé sur les entete de recapitulatifs et petites zones d'affichage",
                default: '',
                width: '',
                value: '',
                liveSearchEnabled: true,
                suggestionsUrl: null,
                validation: { required: false },
                hideConditions: [{ id: 'lieu_type', values: ['club'] }],
              },
              textarea: null,
              entity: null,
              select: null,
              selectClass: null,
              selectMultiple: null,
              selectMultipleClass: null,
              file: null,
              color: null,
              date: null,
              boolean: null,
              mergeTable: null,
              checkbox: null,
              checkboxList: null,
              grid: null,
            },
            // capacite
            {
              text: {
                id: 'capacite',
                type: 'int',
                lib: 'Jauge public',
                ...DEFAULT_FORM_ITEM_LABEL_STYLE,
                align: 'center',
                help: 'Jauge publique dans la configuration maximale, utilisée sur les odres de vente de billetterie, les confirmations, les feuilles de routes et les statistiques de billetterie',
                default: '100',
                width: '',
                value: '',
                liveSearchEnabled: false,
                suggestionsUrl: null,
                validation: { required: false },
                hideConditions: [
                  { id: 'lieu_type', values: ['club'] },
                  { id: 'lieu_section', values: ['hors les murs'] },
                ],
              },
              textarea: null,
              entity: null,
              select: null,
              selectClass: null,
              selectMultiple: null,
              selectMultipleClass: null,
              file: null,
              color: null,
              date: null,
              boolean: null,
              mergeTable: null,
              checkbox: null,
              checkboxList: null,
              grid: null,
            },
            // lieu_capacite_site
            {
              text: {
                id: 'lieu_capacite_site',
                type: 'int',
                lib: 'Jauge site',
                ...DEFAULT_FORM_ITEM_LABEL_STYLE,
                align: 'center',
                help: 'La référence pour la sécurité : public + accredités, utilisé dans le suivi des ventes de billetterie, ne peut être inférieur à la jauge publique',
                default: '',
                width: '',
                value: '',
                liveSearchEnabled: false,
                suggestionsUrl: null,
                validation: { required: false },
                hideConditions: [{ id: 'lieu_type', values: ['autre', 'club'] }],
              },
              textarea: null,
              entity: null,
              select: null,
              selectClass: null,
              selectMultiple: null,
              selectMultipleClass: null,
              file: null,
              color: null,
              date: null,
              boolean: null,
              mergeTable: null,
              checkbox: null,
              checkboxList: null,
              grid: null,
            },
            // color
            {
              text: null,
              textarea: null,
              entity: null,
              select: null,
              selectClass: null,
              selectMultiple: null,
              selectMultipleClass: null,
              file: null,
              color: {
                id: 'color',
                lib: 'Couleur',
                ...DEFAULT_FORM_ITEM_LABEL_STYLE,
                value: '',
                help: 'Code couleur (code HTML) affecté au lieu, sera repris dans les différents récapitulatifs et plannings',
                default: '#FFFFFF',
                width: '',
                validation: { required: false },
                hideConditions: [{ id: 'lieu_type', values: ['club'] }],
              },
              date: null,
              boolean: null,
              mergeTable: null,
              checkbox: null,
              checkboxList: null,
              grid: null,
            },
            // sort_order
            {
              text: {
                id: 'sort_order',
                type: 'int',
                lib: 'Position',
                ...DEFAULT_FORM_ITEM_LABEL_STYLE,
                align: 'center',
                help: "Pour classer forcer l'ordre d'affichage des lieux",
                default: '',
                width: '',
                value: '',
                liveSearchEnabled: false,
                suggestionsUrl: null,
                validation: { required: false },
                hideConditions: [],
              },
              textarea: null,
              entity: null,
              select: null,
              selectClass: null,
              selectMultiple: null,
              selectMultipleClass: null,
              file: null,
              color: null,
              date: null,
              boolean: null,
              mergeTable: null,
              checkbox: null,
              checkboxList: null,
              grid: null,
            },
            // id_contact
            {
              text: {
                id: 'id_contact',
                type: 'int',
                lib: 'Contact',
                ...DEFAULT_FORM_ITEM_LABEL_STYLE,
                align: 'center',
                help: null,
                default: '',
                width: '',
                value: '',
                liveSearchEnabled: false,
                suggestionsUrl: null,
                validation: { required: false },
                hideConditions: [],
              },
              textarea: null,
              entity: null,
              select: null,
              selectClass: null,
              selectMultiple: null,
              selectMultipleClass: null,
              file: null,
              color: null,
              date: null,
              boolean: null,
              mergeTable: null,
              checkbox: null,
              checkboxList: null,
              grid: null,
            },
            // Hidden fields
            {
              text: {
                id: 'id_user_modif',
                type: 'int',
                lib: 'Par',
                ...DEFAULT_FORM_ITEM_LABEL_STYLE,
                align: 'center',
                help: null,
                default: '',
                width: '50',
                value: '',
                liveSearchEnabled: false,
                suggestionsUrl: null,
                validation: { required: false },
                hideConditions: [],
              },
              textarea: null,
              entity: null,
              select: null,
              selectClass: null,
              selectMultiple: null,
              selectMultipleClass: null,
              file: null,
              color: null,
              date: null,
              boolean: null,
              mergeTable: null,
              checkbox: null,
              checkboxList: null,
              grid: null,
            },
            {
              text: null,
              textarea: null,
              entity: null,
              select: null,
              selectClass: null,
              selectMultiple: null,
              selectMultipleClass: null,
              file: null,
              color: null,
              date: {
                id: 'date_modif',
                lib: 'Date Modification',
                ...DEFAULT_FORM_ITEM_LABEL_STYLE,
                value: '',
                default: '',
                help: null,
                width: '110',
                validation: { required: false },
                hideConditions: [],
              },
              boolean: null,
              mergeTable: null,
              checkbox: null,
              checkboxList: null,
              grid: null,
            },
            {
              text: {
                id: 'id_user_crea',
                type: 'int',
                lib: 'Par',
                ...DEFAULT_FORM_ITEM_LABEL_STYLE,
                align: 'center',
                help: null,
                default: '',
                width: '50',
                value: '',
                liveSearchEnabled: false,
                suggestionsUrl: null,
                validation: { required: false },
                hideConditions: [],
              },
              textarea: null,
              entity: null,
              select: null,
              selectClass: null,
              selectMultiple: null,
              selectMultipleClass: null,
              file: null,
              color: null,
              date: null,
              boolean: null,
              mergeTable: null,
              checkbox: null,
              checkboxList: null,
              grid: null,
            },
            {
              text: null,
              textarea: null,
              entity: null,
              select: null,
              selectClass: null,
              selectMultiple: null,
              selectMultipleClass: null,
              file: null,
              color: null,
              date: {
                id: 'date_crea',
                lib: 'Date Création',
                ...DEFAULT_FORM_ITEM_LABEL_STYLE,
                value: '',
                default: '',
                help: null,
                width: '110',
                validation: { required: false },
                hideConditions: [],
              },
              boolean: null,
              mergeTable: null,
              checkbox: null,
              checkboxList: null,
              grid: null,
            },
            {
              text: {
                id: 'id_client',
                type: 'int',
                lib: 'Libellé',
                ...DEFAULT_FORM_ITEM_LABEL_STYLE,
                align: 'center',
                help: null,
                default: '',
                width: '',
                value: '',
                liveSearchEnabled: false,
                suggestionsUrl: null,
                validation: { required: false },
                hideConditions: [],
              },
              textarea: null,
              entity: null,
              select: null,
              selectClass: null,
              selectMultiple: null,
              selectMultipleClass: null,
              file: null,
              color: null,
              date: null,
              boolean: null,
              mergeTable: null,
              checkbox: null,
              checkboxList: null,
              grid: null,
            },
            {
              text: {
                id: 'id_valid',
                type: 'int',
                lib: 'Libellé',
                ...DEFAULT_FORM_ITEM_LABEL_STYLE,
                align: 'center',
                help: null,
                default: '1',
                width: '',
                value: '',
                liveSearchEnabled: false,
                suggestionsUrl: null,
                validation: { required: false },
                hideConditions: [],
              },
              textarea: null,
              entity: null,
              select: null,
              selectClass: null,
              selectMultiple: null,
              selectMultipleClass: null,
              file: null,
              color: null,
              date: null,
              boolean: null,
              mergeTable: null,
              checkbox: null,
              checkboxList: null,
              grid: null,
            },
            {
              text: {
                id: 'id_import_externe',
                type: 'int',
                lib: 'Libellé',
                ...DEFAULT_FORM_ITEM_LABEL_STYLE,
                align: 'center',
                help: null,
                default: '',
                width: '',
                value: '',
                liveSearchEnabled: false,
                suggestionsUrl: null,
                validation: { required: false },
                hideConditions: [],
              },
              textarea: null,
              entity: null,
              select: null,
              selectClass: null,
              selectMultiple: null,
              selectMultipleClass: null,
              file: null,
              color: null,
              date: null,
              boolean: null,
              mergeTable: null,
              checkbox: null,
              checkboxList: null,
              grid: null,
            },
            {
              text: {
                id: 'lib_classification_cnv_lieu',
                type: 'text',
                lib: 'Classification CNM',
                ...DEFAULT_FORM_ITEM_LABEL_STYLE,
                align: 'left',
                help: 'Est utilisée sur les différents exports CNM (déclaration mensuelle, PDF événement et tableau commission 7)',
                default: '',
                width: '',
                value: '',
                liveSearchEnabled: false,
                suggestionsUrl: null,
                validation: { required: false },
                hideConditions: [],
              },
              textarea: null,
              entity: null,
              select: null,
              selectClass: null,
              selectMultiple: null,
              selectMultipleClass: null,
              file: null,
              color: null,
              date: null,
              boolean: null,
              mergeTable: null,
              checkbox: null,
              checkboxList: null,
              grid: null,
            },
            {
              text: {
                id: 'defaut',
                type: 'int',
                lib: 'Libellé',
                ...DEFAULT_FORM_ITEM_LABEL_STYLE,
                align: 'left',
                help: null,
                default: '',
                width: '',
                value: '',
                liveSearchEnabled: false,
                suggestionsUrl: null,
                validation: { required: false },
                hideConditions: [],
              },
              textarea: null,
              entity: null,
              select: null,
              selectClass: null,
              selectMultiple: null,
              selectMultipleClass: null,
              file: null,
              color: null,
              date: null,
              boolean: null,
              mergeTable: null,
              checkbox: null,
              checkboxList: null,
              grid: null,
            },
            {
              text: {
                id: 'montant_utilisation',
                type: 'int',
                lib: 'Libellé',
                ...DEFAULT_FORM_ITEM_LABEL_STYLE,
                align: 'left',
                help: null,
                default: '',
                width: '',
                value: '',
                liveSearchEnabled: false,
                suggestionsUrl: null,
                validation: { required: false },
                hideConditions: [],
              },
              textarea: null,
              entity: null,
              select: null,
              selectClass: null,
              selectMultiple: null,
              selectMultipleClass: null,
              file: null,
              color: null,
              date: null,
              boolean: null,
              mergeTable: null,
              checkbox: null,
              checkboxList: null,
              grid: null,
            },
            {
              text: {
                id: 'montant_location',
                type: 'int',
                lib: 'Libellé',
                ...DEFAULT_FORM_ITEM_LABEL_STYLE,
                align: 'left',
                help: null,
                default: '',
                width: '',
                value: '',
                liveSearchEnabled: false,
                suggestionsUrl: null,
                validation: { required: false },
                hideConditions: [],
              },
              textarea: null,
              entity: null,
              select: null,
              selectClass: null,
              selectMultiple: null,
              selectMultipleClass: null,
              file: null,
              color: null,
              date: null,
              boolean: null,
              mergeTable: null,
              checkbox: null,
              checkboxList: null,
              grid: null,
            },
          ],
        },
        {
          id: 1,
          legend: 'Infos feuille de route',
          subLegend: '*Accès, description interne et coordonnées GPS* pour les artistes.',
          column: 1,
          fields: [
            // acces_pro
            {
              text: null,
              textarea: {
                id: 'acces_pro',
                type: 'text',
                lib: 'Accès pour les artistes',
                ...DEFAULT_FORM_ITEM_LABEL_STYLE,
                value: '',
                help: 'Détail des accès pour les artistes et les partenaires des événements : apparait dans les feuilles de route artiste',
                default: '',
                width: '',
                validation: { required: false },
                hideConditions: [{ id: 'lieu_type', values: ['autre'] }],
              },
              entity: null,
              select: null,
              selectClass: null,
              selectMultiple: null,
              selectMultipleClass: null,
              file: null,
              color: null,
              date: null,
              boolean: null,
              mergeTable: null,
              checkbox: null,
              checkboxList: null,
              grid: null,
            },
            // lieu_description_interne
            {
              text: null,
              textarea: {
                id: 'lieu_description_interne',
                type: 'text',
                lib: 'Description interne',
                ...DEFAULT_FORM_ITEM_LABEL_STYLE,
                value: '',
                help: "Infos internes pour la gestion d'une base de lieux.",
                default: '',
                width: '',
                validation: { required: false },
                hideConditions: [
                  { id: 'lieu_type', values: ['club'] },
                  { id: 'lieu_section', values: ['hors les murs'] },
                ],
              },
              entity: null,
              select: null,
              selectClass: null,
              selectMultiple: null,
              selectMultipleClass: null,
              file: null,
              color: null,
              date: null,
              boolean: null,
              mergeTable: null,
              checkbox: null,
              checkboxList: null,
              grid: null,
            },
            // latitude_gps
            {
              text: {
                id: 'latitude_gps',
                type: 'text',
                lib: 'Latitude GPS',
                ...DEFAULT_FORM_ITEM_LABEL_STYLE,
                align: 'left',
                help: 'Apparaitra sur la feuille de route artiste',
                default: '',
                width: '',
                value: '',
                liveSearchEnabled: false,
                suggestionsUrl: null,
                validation: { required: false },
                hideConditions: [],
              },
              textarea: null,
              entity: null,
              select: null,
              selectClass: null,
              selectMultiple: null,
              selectMultipleClass: null,
              file: null,
              color: null,
              date: null,
              boolean: null,
              mergeTable: null,
              checkbox: null,
              checkboxList: null,
              grid: null,
            },
            // longitude_gps
            {
              text: {
                id: 'longitude_gps',
                type: 'text',
                lib: 'Longitude GPS',
                ...DEFAULT_FORM_ITEM_LABEL_STYLE,
                align: 'left',
                help: 'Apparaitra sur la feuille de route artiste',
                default: '',
                width: '',
                value: '',
                liveSearchEnabled: false,
                suggestionsUrl: null,
                validation: { required: false },
                hideConditions: [],
              },
              textarea: null,
              entity: null,
              select: null,
              selectClass: null,
              selectMultiple: null,
              selectMultipleClass: null,
              file: null,
              color: null,
              date: null,
              boolean: null,
              mergeTable: null,
              checkbox: null,
              checkboxList: null,
              grid: null,
            },
          ],
        },
        {
          id: 2,
          legend: 'Adresse',
          subLegend: '**Adresse postale** et code postal du lieu.',
          column: 2,
          fields: [
            // adr1
            {
              text: {
                id: 'adr1',
                type: 'text',
                lib: 'Adresse',
                ...DEFAULT_FORM_ITEM_LABEL_STYLE,
                align: 'left',
                help: null,
                default: '',
                width: '',
                value: '',
                liveSearchEnabled: false,
                suggestionsUrl: null,
                validation: { required: false },
                hideConditions: [],
              },
              textarea: null,
              entity: null,
              select: null,
              selectClass: null,
              selectMultiple: null,
              selectMultipleClass: null,
              file: null,
              color: null,
              date: null,
              boolean: null,
              mergeTable: null,
              checkbox: null,
              checkboxList: null,
              grid: null,
            },
            // adr2
            {
              text: {
                id: 'adr2',
                type: 'text',
                lib: 'Adr. 2',
                ...DEFAULT_FORM_ITEM_LABEL_STYLE,
                align: 'left',
                help: null,
                default: '',
                width: '',
                value: '',
                liveSearchEnabled: false,
                suggestionsUrl: null,
                validation: { required: false },
                hideConditions: [],
              },
              textarea: null,
              entity: null,
              select: null,
              selectClass: null,
              selectMultiple: null,
              selectMultipleClass: null,
              file: null,
              color: null,
              date: null,
              boolean: null,
              mergeTable: null,
              checkbox: null,
              checkboxList: null,
              grid: null,
            },
            // adr3
            {
              text: {
                id: 'adr3',
                type: 'text',
                lib: 'Adr. 3',
                ...DEFAULT_FORM_ITEM_LABEL_STYLE,
                align: 'left',
                help: null,
                default: '',
                width: '',
                value: '',
                liveSearchEnabled: false,
                suggestionsUrl: null,
                validation: { required: false },
                hideConditions: [],
              },
              textarea: null,
              entity: null,
              select: null,
              selectClass: null,
              selectMultiple: null,
              selectMultipleClass: null,
              file: null,
              color: null,
              date: null,
              boolean: null,
              mergeTable: null,
              checkbox: null,
              checkboxList: null,
              grid: null,
            },
            // cp
            {
              text: {
                id: 'cp',
                type: 'text',
                lib: 'Cp',
                ...DEFAULT_FORM_ITEM_LABEL_STYLE,
                align: 'left',
                help: null,
                default: '',
                width: '',
                value: '',
                liveSearchEnabled: false,
                suggestionsUrl: null,
                validation: { required: false },
                hideConditions: [],
              },
              textarea: null,
              entity: null,
              select: null,
              selectClass: null,
              selectMultiple: null,
              selectMultipleClass: null,
              file: null,
              color: null,
              date: null,
              boolean: null,
              mergeTable: null,
              checkbox: null,
              checkboxList: null,
              grid: null,
            },
            // ville
            {
              text: {
                id: 'ville',
                type: 'text',
                lib: 'Ville',
                ...DEFAULT_FORM_ITEM_LABEL_STYLE,
                align: 'left',
                help: null,
                default: '',
                width: '',
                value: '',
                liveSearchEnabled: false,
                suggestionsUrl: null,
                validation: { required: false },
                hideConditions: [],
              },
              textarea: null,
              entity: null,
              select: null,
              selectClass: null,
              selectMultiple: null,
              selectMultipleClass: null,
              file: null,
              color: null,
              date: null,
              boolean: null,
              mergeTable: null,
              checkbox: null,
              checkboxList: null,
              grid: null,
            },
            // pays
            {
              text: {
                id: 'pays',
                type: 'text',
                lib: 'Pays',
                ...DEFAULT_FORM_ITEM_LABEL_STYLE,
                align: 'left',
                help: null,
                default: '',
                width: '',
                value: '',
                liveSearchEnabled: false,
                suggestionsUrl: null,
                validation: { required: false },
                hideConditions: [],
              },
              textarea: null,
              entity: null,
              select: null,
              selectClass: null,
              selectMultiple: null,
              selectMultipleClass: null,
              file: null,
              color: null,
              date: null,
              boolean: null,
              mergeTable: null,
              checkbox: null,
              checkboxList: null,
              grid: null,
            },
          ],
        },
      ],
    },
    {
      id: 1,
      legend: '*Communication*',
      subLegend: 'Textes **promo** et descriptions.',
      displayAnchors: true,
      fieldsets: [
        {
          id: 3,
          legend: 'Promo, communication',
          subLegend: 'Promo, communication',
          column: 0,
          fields: [
            // lieu_link
            {
              text: {
                id: 'lieu_link',
                type: 'text',
                lib: 'Lien',
                ...DEFAULT_FORM_ITEM_LABEL_STYLE,
                align: 'left',
                help: null,
                default: '',
                width: '',
                value: '',
                liveSearchEnabled: false,
                suggestionsUrl: null,
                validation: { required: false },
                hideConditions: [],
              },
              textarea: null,
              entity: null,
              select: null,
              selectClass: null,
              selectMultiple: null,
              selectMultipleClass: null,
              file: null,
              color: null,
              date: null,
              boolean: null,
              mergeTable: null,
              checkbox: null,
              checkboxList: null,
              grid: null,
            },
          ],
        },
        {
          id: 4,
          legend: 'Descriptions',
          subLegend: 'Textes **courts** et *longs* pour la communication.',
          column: 1,
          fields: [
            // translated_lib_lieu_public
            {
              text: null,
              textarea: {
                id: 'translated_lib_lieu_public',
                type: 'text',
                lib: 'Nom public, traduction',
                ...DEFAULT_FORM_ITEM_LABEL_STYLE,
                value: '',
                help: null,
                default: '',
                width: '',
                validation: { required: false },
                hideConditions: [],
              },
              entity: null,
              select: null,
              selectClass: null,
              selectMultiple: null,
              selectMultipleClass: null,
              file: null,
              color: null,
              date: null,
              boolean: null,
              mergeTable: null,
              checkbox: null,
              checkboxList: null,
              grid: null,
            },
            // acces_public
            {
              text: null,
              textarea: {
                id: 'acces_public',
                type: 'text',
                lib: 'Accès pour le public',
                ...DEFAULT_FORM_ITEM_LABEL_STYLE,
                value: '',
                help: 'Détail des accès pour le public, apparait sur les pdf de mise en vente de billetterie, sera utilisé pour les exports vers les agendas culturels partenaires',
                default: '',
                width: '',
                validation: { required: false },
                hideConditions: [],
              },
              entity: null,
              select: null,
              selectClass: null,
              selectMultiple: null,
              selectMultipleClass: null,
              file: null,
              color: null,
              date: null,
              boolean: null,
              mergeTable: null,
              checkbox: null,
              checkboxList: null,
              grid: null,
            },
            // translated_acces_public
            {
              text: null,
              textarea: {
                id: 'translated_acces_public',
                type: 'text',
                lib: 'Accès pour le public (traduction)',
                ...DEFAULT_FORM_ITEM_LABEL_STYLE,
                value: '',
                help: 'Détail des accès pour le public, apparait sur les pdf de mise en vente de billetterie, sera utilisé pour les exports vers les agendas culturels partenaires',
                default: '',
                width: '',
                validation: { required: false },
                hideConditions: [],
              },
              entity: null,
              select: null,
              selectClass: null,
              selectMultiple: null,
              selectMultipleClass: null,
              file: null,
              color: null,
              date: null,
              boolean: null,
              mergeTable: null,
              checkbox: null,
              checkboxList: null,
              grid: null,
            },
            // lieu_subtitle
            {
              text: {
                id: 'lieu_subtitle',
                type: 'text',
                lib: 'Sous titre',
                ...DEFAULT_FORM_ITEM_LABEL_STYLE,
                align: 'left',
                help: null,
                default: '',
                width: '',
                value: '',
                liveSearchEnabled: false,
                suggestionsUrl: null,
                validation: { required: false },
                hideConditions: [],
              },
              textarea: null,
              entity: null,
              select: null,
              selectClass: null,
              selectMultiple: null,
              selectMultipleClass: null,
              file: null,
              color: null,
              date: null,
              boolean: null,
              mergeTable: null,
              checkbox: null,
              checkboxList: null,
              grid: null,
            },
            // lieu_translated_subtitle
            {
              text: {
                id: 'lieu_translated_subtitle',
                type: 'text',
                lib: 'Traduction Sous titre',
                ...DEFAULT_FORM_ITEM_LABEL_STYLE,
                align: 'left',
                help: null,
                default: '',
                width: '',
                value: '',
                liveSearchEnabled: false,
                suggestionsUrl: null,
                validation: { required: false },
                hideConditions: [],
              },
              textarea: null,
              entity: null,
              select: null,
              selectClass: null,
              selectMultiple: null,
              selectMultipleClass: null,
              file: null,
              color: null,
              date: null,
              boolean: null,
              mergeTable: null,
              checkbox: null,
              checkboxList: null,
              grid: null,
            },
            // description_publique
            {
              text: null,
              textarea: {
                id: 'description_publique',
                type: 'text',
                lib: 'Description publique',
                ...DEFAULT_FORM_ITEM_LABEL_STYLE,
                value: '',
                help: 'Description du lieu, pour le public, servira pour les exports vers les agendas culturels partenaires',
                default: '',
                width: '',
                validation: { required: false },
                hideConditions: [],
              },
              entity: null,
              select: null,
              selectClass: null,
              selectMultiple: null,
              selectMultipleClass: null,
              file: null,
              color: null,
              date: null,
              boolean: null,
              mergeTable: null,
              checkbox: null,
              checkboxList: null,
              grid: null,
            },
            // translated_description_publique
            {
              text: null,
              textarea: {
                id: 'translated_description_publique',
                type: 'text',
                lib: 'Traduction Description publique',
                ...DEFAULT_FORM_ITEM_LABEL_STYLE,
                value: '',
                help: 'Description du lieu, pour le public, servira pour les exports vers les agendas culturels partenaires',
                default: 'Description publique',
                width: '',
                validation: { required: false },
                hideConditions: [],
              },
              entity: null,
              select: null,
              selectClass: null,
              selectMultiple: null,
              selectMultipleClass: null,
              file: null,
              color: null,
              date: null,
              boolean: null,
              mergeTable: null,
              checkbox: null,
              checkboxList: null,
              grid: null,
            },
            // description_courte
            {
              text: null,
              textarea: {
                id: 'description_courte',
                type: 'text',
                lib: 'Description courte',
                ...DEFAULT_FORM_ITEM_LABEL_STYLE,
                value: '',
                help: 'Description du lieu, pour le public, servira pour les exports vers les agendas culturels partenaires',
                default: '',
                width: '',
                validation: { required: false },
                hideConditions: [],
              },
              entity: null,
              select: null,
              selectClass: null,
              selectMultiple: null,
              selectMultipleClass: null,
              file: null,
              color: null,
              date: null,
              boolean: null,
              mergeTable: null,
              checkbox: null,
              checkboxList: null,
              grid: null,
            },
            // translated_description_courte
            {
              text: null,
              textarea: {
                id: 'translated_description_courte',
                type: 'text',
                lib: 'Traduction',
                ...DEFAULT_FORM_ITEM_LABEL_STYLE,
                value: '',
                help: 'Description du lieu, pour le public, servira pour les exports vers les agendas culturels partenaires',
                default: '',
                width: '',
                validation: { required: false },
                hideConditions: [],
              },
              entity: null,
              select: null,
              selectClass: null,
              selectMultiple: null,
              selectMultipleClass: null,
              file: null,
              color: null,
              date: null,
              boolean: null,
              mergeTable: null,
              checkbox: null,
              checkboxList: null,
              grid: null,
            },
            // lieu_photo (hidden)
            {
              text: null,
              textarea: null,
              entity: null,
              select: null,
              selectClass: null,
              selectMultiple: null,
              selectMultipleClass: null,
              file: {
                id: 'lieu_photo',
                lib: 'Photo',
                ...DEFAULT_FORM_ITEM_LABEL_STYLE,
                value: '',
                help: null,
                width: '30',
                uploadUrl: '/api/upload',
                validation: { required: false },
                hideConditions: [],
              },
              color: null,
              date: null,
              boolean: null,
              mergeTable: null,
              checkbox: null,
              checkboxList: null,
              grid: null,
            },
            // lieu_photo_2 (hidden)
            {
              text: null,
              textarea: null,
              entity: null,
              select: null,
              selectClass: null,
              selectMultiple: null,
              selectMultipleClass: null,
              file: {
                id: 'lieu_photo_2',
                lib: 'Photo 2',
                ...DEFAULT_FORM_ITEM_LABEL_STYLE,
                value: '',
                help: null,
                width: '30',
                uploadUrl: '/api/upload',
                validation: { required: false },
                hideConditions: [],
              },
              color: null,
              date: null,
              boolean: null,
              mergeTable: null,
              checkbox: null,
              checkboxList: null,
              grid: null,
            },
            // add_lieu_photo
            {
              text: null,
              textarea: null,
              entity: null,
              select: null,
              selectClass: null,
              selectMultiple: null,
              selectMultipleClass: null,
              file: {
                id: 'add_lieu_photo',
                lib: 'Photo',
                ...DEFAULT_FORM_ITEM_LABEL_STYLE,
                value: '',
                help: null,
                width: '',
                uploadUrl: '/api/upload',
                validation: { required: true },
                hideConditions: [],
              },
              color: null,
              date: null,
              boolean: null,
              mergeTable: null,
              checkbox: null,
              checkboxList: null,
              grid: null,
            },
            // add_lieu_photo_2
            {
              text: null,
              textarea: null,
              entity: null,
              select: null,
              selectClass: null,
              selectMultiple: null,
              selectMultipleClass: null,
              file: {
                id: 'add_lieu_photo_2',
                lib: 'Photo 2',
                ...DEFAULT_FORM_ITEM_LABEL_STYLE,
                value: '',
                help: null,
                width: '',
                uploadUrl: '/api/upload',
                validation: { required: true },
                hideConditions: [],
              },
              color: null,
              date: null,
              boolean: null,
              mergeTable: null,
              checkbox: null,
              checkboxList: null,
              grid: null,
            },
          ],
        },
      ],
    },
    {
      id: 2,
      legend: 'Fichiers',
      subLegend: null,
      displayAnchors: true,
      fieldsets: [
        {
          id: 5,
          legend: 'Ajouter un fichier',
          subLegend: 'Ajouter un fichier',
          column: 0,
          fields: [
            // lieu_file_id (hidden)
            {
              text: null,
              textarea: null,
              entity: null,
              select: null,
              selectClass: null,
              selectMultiple: null,
              selectMultipleClass: null,
              file: {
                id: 'lieu_file_id',
                lib: 'Libellé',
                ...DEFAULT_FORM_ITEM_LABEL_STYLE,
                value: '',
                help: null,
                width: '',
                uploadUrl: '/api/upload',
                validation: { required: true },
                hideConditions: [],
              },
              color: null,
              date: null,
              boolean: null,
              mergeTable: null,
              checkbox: null,
              checkboxList: null,
              grid: null,
            },
            // lieu_file_lib
            {
              text: {
                id: 'lieu_file_lib',
                type: 'text',
                lib: 'Titre',
                ...DEFAULT_FORM_ITEM_LABEL_STYLE,
                align: 'left',
                help: null,
                default: '',
                width: '',
                value: '',
                liveSearchEnabled: false,
                suggestionsUrl: null,
                validation: { required: true },
                hideConditions: [],
              },
              textarea: null,
              entity: null,
              select: null,
              selectClass: null,
              selectMultiple: null,
              selectMultipleClass: null,
              file: null,
              color: null,
              date: null,
              boolean: null,
              mergeTable: null,
              checkbox: null,
              checkboxList: null,
              grid: null,
            },
            // lieu_file_section
            {
              text: {
                id: 'lieu_file_section',
                type: 'text',
                lib: 'Section',
                ...DEFAULT_FORM_ITEM_LABEL_STYLE,
                align: 'left',
                help: null,
                default: '',
                width: '',
                value: '',
                liveSearchEnabled: false,
                suggestionsUrl: null,
                validation: { required: true },
                hideConditions: [],
              },
              textarea: null,
              entity: null,
              select: null,
              selectClass: null,
              selectMultiple: null,
              selectMultipleClass: null,
              file: null,
              color: null,
              date: null,
              boolean: null,
              mergeTable: null,
              checkbox: null,
              checkboxList: null,
              grid: null,
            },
            // lieu_file_data
            {
              text: null,
              textarea: null,
              entity: null,
              select: null,
              selectClass: null,
              selectMultiple: null,
              selectMultipleClass: null,
              file: {
                id: 'lieu_file_data',
                lib: 'Fichier',
                ...DEFAULT_FORM_ITEM_LABEL_STYLE,
                value: '',
                help: null,
                width: '',
                uploadUrl: '/api/upload',
                validation: { required: false },
                hideConditions: [],
              },
              color: null,
              date: null,
              boolean: null,
              mergeTable: null,
              checkbox: null,
              checkboxList: null,
              grid: null,
            },
          ],
        },
      ],
    },
    {
      id: 3,
      legend: 'Contacts',
      subLegend: 'Champs contact (mock)',
      displayAnchors: true,
      fieldsets: [
        {
          id: 6,
          legend: 'Contact — variantes',
          subLegend: null,
          column: 0,
          fields: [
            {
              text: null,
              textarea: null,
              select: null,
              selectClass: null,
              selectMultiple: null,
              selectMultipleClass: null,
              file: null,
              color: null,
              date: null,
              boolean: null,
              mergeTable: null,
              checkbox: null,
              checkboxList: null,
              grid: null,
              entity: {
                id: 'lieu_contact_vide',
                lib: 'Contact (vide)',
                ...DEFAULT_FORM_ITEM_LABEL_STYLE,
                values: [],
                displayedValues: [],
                multiple: false,
                baseFormUrl: '/form/contact/new?context=lieu',
                default: '',
                help: null,
                width: '',
                validation: { required: false },
                hideConditions: [],
              },
            },
            {
              text: null,
              textarea: null,
              select: null,
              selectClass: null,
              selectMultiple: null,
              selectMultipleClass: null,
              file: null,
              color: null,
              date: null,
              boolean: null,
              mergeTable: null,
              checkbox: null,
              checkboxList: null,
              grid: null,
              entity: {
                id: 'lieu_contact_selectionne',
                lib: 'Contact (sélectionné)',
                ...DEFAULT_FORM_ITEM_LABEL_STYLE,
                values: ['42'],
                displayedValues: ['Jean Dupont'],
                multiple: false,
                baseFormUrl: '/form/contact/new?context=lieu',
                default: '',
                help: null,
                width: '50',
                validation: { required: false },
                hideConditions: [],
              },
            },
            {
              text: null,
              textarea: null,
              select: null,
              selectClass: null,
              selectMultiple: null,
              selectMultipleClass: null,
              file: null,
              color: null,
              date: null,
              boolean: null,
              mergeTable: null,
              checkbox: null,
              checkboxList: null,
              grid: null,
              entity: {
                id: 'lieu_contact_requis',
                lib: 'Contact (requis)',
                ...DEFAULT_FORM_ITEM_LABEL_STYLE,
                values: [],
                displayedValues: [],
                multiple: false,
                baseFormUrl: '/form/contact/new?context=lieu',
                default: '',
                help: 'Obligatoire pour valider la fiche',
                width: '100',
                validation: { required: true },
                hideConditions: [],
              },
            },
            {
              text: null,
              textarea: null,
              select: null,
              selectClass: null,
              selectMultiple: null,
              selectMultipleClass: null,
              file: null,
              color: null,
              date: null,
              boolean: null,
              mergeTable: null,
              checkbox: null,
              checkboxList: null,
              grid: null,
              entity: {
                id: 'lieu_contact_multiple',
                lib: 'Contacts (multiple)',
                ...DEFAULT_FORM_ITEM_LABEL_STYLE,
                values: ['42', '99'],
                displayedValues: ['Jean Dupont', 'Marie Martin'],
                multiple: true,
                baseFormUrl: '/form/contact/new?context=lieu',
                default: '',
                help: null,
                width: '100',
                validation: { required: false },
                hideConditions: [],
              },
            },
          ],
        },
      ],
    },
    {
      id: 4,
      legend: 'CheckboxList',
      subLegend: 'Variantes du champ *checkboxList* — layouts, options et contenus de cellules.',
      displayAnchors: true,
      fieldsets: [
        {
          id: 7,
          legend: 'CheckboxList — variantes',
          subLegend: 'Layouts `wrap` / `column`, multi-groupes dans un même champ, cellules composites.',
          column: 0,
          fields: [
            // cl_prestations — multi-groupes : prestations (wrap) + aménagements (column)
            {
              text: null,
              textarea: null,
              entity: null,
              select: null,
              selectClass: null,
              selectMultiple: null,
              selectMultipleClass: null,
              file: null,
              color: null,
              date: null,
              boolean: null,
              mergeTable: null,
              checkbox: null,
              checkboxList: {
                id: 'cl_prestations',
                values: ['bar', 'wifi', 'pmr'],
                ...DEFAULT_FORM_ITEM_LABEL_STYLE,
                help: '**Multi-groupes** : prestations en wrap (headers ignorés) puis aménagements en column (tableau avec headers). Une seule valeur à la soumission.',
                default: [],
                headers: mockCheckboxListHeadersAmenagements,
                groups: mockCheckboxListGroupsPrestationsAndAmenagements,
                validation: { required: false },
                hideConditions: [],
              },
              grid: null,
            },
            // cl_canaux — rich cells
            {
              text: null,
              textarea: null,
              entity: null,
              select: null,
              selectClass: null,
              selectMultiple: null,
              selectMultipleClass: null,
              file: null,
              color: null,
              date: null,
              boolean: null,
              mergeTable: null,
              checkbox: null,
              checkboxList: {
                id: 'cl_canaux',
                values: ['site', 'newsletter'],
                ...DEFAULT_FORM_ITEM_LABEL_STYLE,
                help: 'Cellules riches : markdown, couleurs, images, liens externes (openTabUrl).',
                default: ['newsletter'],
                headers: [],
                groups: mockCheckboxListGroupsRichCanaux,
                validation: { required: false },
                hideConditions: [],
              },
              grid: null,
            },
            // cl_mixte — two groups, different layouts
            {
              text: null,
              textarea: null,
              entity: null,
              select: null,
              selectClass: null,
              selectMultiple: null,
              selectMultipleClass: null,
              file: null,
              color: null,
              date: null,
              boolean: null,
              mergeTable: null,
              checkbox: null,
              checkboxList: {
                id: 'cl_mixte',
                values: ['concert', 'festival'],
                ...DEFAULT_FORM_ITEM_LABEL_STYLE,
                help: 'Deux groupes dans un même champ : premier en wrap (3 options), second en column (4 options).',
                default: [],
                headers: [],
                groups: mockCheckboxListGroupsMixedLayouts,
                validation: { required: false },
                hideConditions: [],
              },
              grid: null,
            },
            // cl_creneaux — no group header
            {
              text: null,
              textarea: null,
              entity: null,
              select: null,
              selectClass: null,
              selectMultiple: null,
              selectMultipleClass: null,
              file: null,
              color: null,
              date: null,
              boolean: null,
              mergeTable: null,
              checkbox: null,
              checkboxList: {
                id: 'cl_creneaux',
                values: ['soir'],
                ...DEFAULT_FORM_ITEM_LABEL_STYLE,
                help: 'Groupe sans légende ni icône (pas de header de fieldset).',
                default: [],
                headers: [],
                groups: mockCheckboxListGroupsNoHeader,
                validation: { required: false },
                hideConditions: [],
              },
              grid: null,
            },
            // cl_seul — single option
            {
              text: null,
              textarea: null,
              entity: null,
              select: null,
              selectClass: null,
              selectMultiple: null,
              selectMultipleClass: null,
              file: null,
              color: null,
              date: null,
              boolean: null,
              mergeTable: null,
              checkbox: null,
              checkboxList: {
                id: 'cl_seul',
                values: [],
                ...DEFAULT_FORM_ITEM_LABEL_STYLE,
                help: 'Cas limite : une seule option dans le groupe.',
                default: [],
                headers: [],
                groups: mockCheckboxListGroupsSingleOption,
                validation: { required: false },
                hideConditions: [],
              },
              grid: null,
            },
            // cl_requis — required validation
            {
              text: null,
              textarea: null,
              entity: null,
              select: null,
              selectClass: null,
              selectMultiple: null,
              selectMultipleClass: null,
              file: null,
              color: null,
              date: null,
              boolean: null,
              mergeTable: null,
              checkbox: null,
              checkboxList: {
                id: 'cl_requis',
                values: [],
                ...DEFAULT_FORM_ITEM_LABEL_STYLE,
                help: 'Champ requis : au moins une option doit être cochée pour valider le formulaire.',
                default: [],
                headers: [],
                groups: mockCheckboxListGroupsRequired,
                validation: { required: true },
                hideConditions: [],
              },
              grid: null,
            },
            // cl_headers — column layout with table headers
            {
              text: null,
              textarea: null,
              entity: null,
              select: null,
              selectClass: null,
              selectMultiple: null,
              selectMultipleClass: null,
              file: null,
              color: null,
              date: null,
              boolean: null,
              mergeTable: null,
              checkbox: null,
              checkboxList: {
                id: 'cl_headers',
                values: ['pmr'],
                ...DEFAULT_FORM_ITEM_LABEL_STYLE,
                help: 'Layout **column** avec `headers` : rendu tableau (colonne checkbox + cellules alignées sous chaque en-tête).',
                default: [],
                headers: mockCheckboxListHeadersAmenagements,
                groups: mockCheckboxListGroupsColumnWithHeaders,
                validation: { required: false },
                hideConditions: [],
              },
              grid: null,
            },
            // cl_masque — hideConditions when lieu_type is club
            {
              text: null,
              textarea: null,
              entity: null,
              select: null,
              selectClass: null,
              selectMultiple: null,
              selectMultipleClass: null,
              file: null,
              color: null,
              date: null,
              boolean: null,
              mergeTable: null,
              checkbox: null,
              checkboxList: {
                id: 'cl_masque',
                values: ['rock'],
                ...DEFAULT_FORM_ITEM_LABEL_STYLE,
                help: 'Masqué quand le type de salle est « club » (voir onglet Suivi de prod).',
                default: [],
                headers: [],
                groups: [mockCheckboxListGroups[0]],
                validation: { required: false },
                hideConditions: [{ id: 'lieu_type', values: ['club'] }],
              },
              grid: null,
            },
          ],
        },
      ],
    },
    {
      id: 5,
      legend: 'Radio & Grille',
      subLegend: 'Champ *radioList* (choix exclusif groupé), *radio* (option de matrice) et grille stylée.',
      displayAnchors: true,
      fieldsets: [
        {
          id: 11,
          legend: 'Radio list — choix exclusif',
          subLegend: 'Une seule option parmi les groupes. `wrap` affiche les options sur une ligne ; `column` les empile (tableau si `headers`).',
          column: 0,
          fields: [
            createMockFormItemRadioList({
              id: 'radio_list_creneau',
              lib: 'Créneau',
              value: 'matin',
              default: 'matin',
              help: 'Options sur une ligne (`layout: wrap`).',
              groups: mockCheckboxListGroupsNoHeader,
            }),
            createMockFormItemRadioList({
              id: 'radio_list_equipement',
              lib: 'Équipement principal',
              value: 'son',
              default: 'son',
              help: 'Options empilées (`layout: column`).',
              groups: [mockCheckboxListGroups[1]],
            }),
          ],
        },
        {
          id: 8,
          legend: 'Radio — visibilité',
          subLegend: 'Les options partagent le même `id` ; seule la valeur cochée est envoyée.',
          column: 0,
          fields: [
            ...createMockRadioGroup({
              id: 'radio_visibilite',
              selected: 'equipe',
              options: [
                { value: 'prive', lib: 'Privé — moi uniquement' },
                { value: 'equipe', lib: 'Équipe — les membres du projet' },
                { value: 'public', lib: 'Public — tout le monde' },
              ],
            }),
          ],
        },
        {
          id: 10,
          legend: 'Radio — facturation',
          subLegend: 'Groupe distinct : un choix ici est indépendant de la visibilité.',
          column: 0,
          fields: [
            ...createMockRadioGroup({
              id: 'radio_facturation',
              required: true,
              options: [
                { value: 'mensuelle', lib: 'Mensuelle' },
                { value: 'annuelle', lib: 'Annuelle' },
              ],
            }),
          ],
        },
        {
          id: 9,
          legend: 'Grille — matrice de droits',
          subLegend: 'Radios en matrice, en-têtes colorés, lignes groupées et pied de tableau.',
          column: 0,
          fields: [createMockFormItemGridRights()],
        },
      ],
    },
  ],
  sendFormLib: 'Enregistrer les modifications',
};
